import * as React from "react";

/** The search box's text, for marking the match in each metric's name. */
export const MetricSearchContext = React.createContext("");
